<template>
  <div>
    <nav-bar/>
    <buy-art/>
    <div class="padded">
      <b-table striped hover :items="purchases" :fields="fields"></b-table>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import BuyArt from '@/components/BuyArt'
import Web3 from 'web3'
import {PUBLIC_KEY} from '../config';

export default {
  name: 'collectors',
  components: {
    'nav-bar': NavBar,
    'buy-art': BuyArt
  },
  data () {
    return {
      //sortBy: 'blockNumber',
      fields: [ 'collectorName', 'collectorAddress', 'blockNumber', 'priceEth' ],
      web3: null,
      web3Provider: null,
      contracts: {},
      account: null,
      numPurchases: 0,
      purchases: []
    }
  },
  mounted () {
    this.getProvider()
  },
  methods: {
    getProvider () {
      // Checking if Web3 has been injected by the browser (Mist/MetaMask)
      if (typeof web3 !== 'undefined') {
        // Use Mist/MetaMask's provider
        this.web3Provider = web3.currentProvider
        web3 = new Web3(this.web3Provider)
      } else {
        // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
        this.web3Provider = new Web3.providers.HttpProvider('http://localhost:8545')
        web3 = new Web3(this.web3Provider)
      }
      this.getContract()
    },
    getContract () {
      var Art30Artifact = require('../../build/contracts/Art30.json')
      this.contracts.Art30 = this.$TruffleContract(Art30Artifact)
      this.contracts.Art30.setProvider(this.web3Provider)
      this.networkCheck()
      this.getAccount()
      this.getPurchases()
    },
    networkCheck () {
      web3.version.getNetwork((err, netId) => {
        if (err) {
          console.log(err)
          return
        }
        switch (netId) {
          case '1':
            console.log('This is mainnet')
            break
          case '2':
            console.log('This is the deprecated Morden test network.')
            break
          case '3':
            console.log('This is the ropsten test network.')
            break
          default:
            console.log('This is an unknown network.')
        }
      })
    },
    getPurchases() {
      var art30Instance;
      this.contracts.Art30.deployed().then((instance) => {
        art30Instance = instance
        return art30Instance.getNumPurchases()
      }).then((result) => {
        this.numPurchases = result
        var promises = [];
        for (var i = 0; i < result; ++i)
        {
          promises.push(art30Instance.getPurchaseCollector(i))
        }
        return Promise.all(promises)
      }).then((result) => {
        var promises = [];
        for (var i = 0; i < result.length; ++i)
        {
          var purchase = {}
          purchase.collectorAddress = result[i]
          this.purchases.push(purchase)
          promises.push(art30Instance.getPurchasePrice(i))
        }
        return Promise.all(promises)
      }).then((result) => {
        var promises = []
        for (var i = 0; i < result.length; ++i)
        {
          Object.assign(this.purchases[i], {priceEth: web3.fromWei(result[i], 'ether').toPrecision(8)})
          this.$set(this.purchases, i, this.purchases[i])
          promises.push(art30Instance.getPurchaseBlockNumber(i))
        }
        return Promise.all(promises)
      }).then((result) => {
        var promises = []
        for (var i = 0; i < result.length; ++i)
        {
          Object.assign(this.purchases[i], {blockNumber: result[i].valueOf()})
          this.$set(this.purchases, i, this.purchases[i])
          promises.push(art30Instance.getCollectorDisplayName(this.purchases[i].collectorAddress))
        }
        return Promise.all(promises)
      }).then((result) => {
        var promises = []
        for (var i = 0; i < result.length; ++i)
        {
          Object.assign(this.purchases[i], {collectorName: result[i]})
          this.$set(this.purchases, i, this.purchases[i])
          //promises.push(art30Instance.getCollectorDisplayName(this.purchases[i].collectorAddress))
        }
        this.purchases = this.purchases.reverse()
        //return Promise.all(promises)
      }).catch((err) => {
        console.log(err.message)
      })
    },
    getAccount() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        if (accounts.length != 0)
        {
          this.account = accounts[0]
          console.log(this.account)
        }
      })
    }
  }
}
</script>

<style scoped>
.on-the-left {
    text-align: left;
}

.padded {
    padding: 0 10pc;
}
</style>


// WEBPACK FOOTER //
// src/components/Collectors.vue